<!-- Html code for amcservice create-->
<template>
  <div style="padding-bottom: 180px; margin-top: -10px">
    <!-- page title for amcservice create -->
    <GlobalHeader title="Product Bundle" @redirectPage="redirectPage"></GlobalHeader>
    <!-- Validation for amcservice -->
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>
          <b-alert
            class="alert-transparent alert-danger"
            :show="error_show && errors.any()"
          >
            <button
              type="button"
              @click="error_show = !error_show"
              class="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div
              v-for="item in errors.items"
              :key="item.id"
              v-if="item.scope == 'product-bundle-form'"
            >
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <!-- page header for amcservice create -->
    <b-form
      class="mt-3 pt-1"
      id="product_form"
      data-vv-scope="product-bundle-form"
      @submit.prevent="onSubmit('product-bundle-form')"
      @click="roundOffvalue()"
      style="margin-left: 3px; margin-right: 3px"
    >
      <!--  amcservice name -->
      <b-row style="max-width: 1000px">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Name'"
            label-class="required"
            label-for="pdt_name"
            class="mb-3"
          >
            <b-form-input
              type="text"
              size="sm"
              class="form-control"
              name="pdt_name"
              v-model.trim="field.pdt_name"
              data-vv-name="product bundle name"
              v-validate="'required|max:150'"
            />
          </b-form-group>
          <b-form-group label="Unit" label-for="unit" class="mb-3">
            <template slot="label">
              Unit
              <span class="text-danger">*</span>
              <span
                v-b-tooltip.top="
                  'The product will be measured in terms of this unit(e.g: kg.dozen)'
                "
              >
                <i class="la la-question-circle la-lg"></i>
              </span>
            </template>
            <v-select
              :clearable="false"
              size="sm"
              :options="unit_list"
              label="label"
              index="value"
              name="pdt_unit"
              data-vv-name="product unit"
              v-model.trim="field.pdt_unit"
              v-validate="'required'"
            ></v-select>
            <template slot="option" slot-scope="option">{{
              option.label
            }}</template>
          </b-form-group>
        </b-col>
      </b-row>
      <!--  amcservice unit -->

      <b-row
        style="max-width: 1000px"
        class="mt-5"
        v-if="goods_items.length > 0"
      >
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <p>
            Associate Products
            <span class="text-danger">*</span>
          </p>
          <!-- Table for amcservice products -->
          <table
            class="table table-bordered sales-table last-child-border-none total-table"
          >
            <thead>
              <!-- <th width="1%"></th> -->
              <th width="30%">Product details</th>
              <!-- <th>Description</th> -->
              <th width="10%" class="text-right">Quantity</th>
              <th width="10%" class="text-right">
                Selling Price ( {{ orgCurrency }} )
              </th>
              <th width="1%"></th>
            </thead>
            <tbody>
              <!-- Product index -->
              <tr v-for="(item, index) in goods_items" :key="index">
                <!-- <td>{{ index + 1 }}</td> -->
                <td
                  @click="removeproduct($event, index, 'goods_items')"
                  class="show-product-details"
                >
                  <!-- Product search -->
                  <span class="d-flex">
                    <vue-bootstrap-typeahead
                      style="width: 100%"
                      @input="productlist($event, index, 'goods_items')"
                      v-model="item.pdt_detail_id"
                      :id="'vuebootsearcher' + 'goods_items' + index"
                      name="pdt_detail_id[]"
                      :data="item.products"
                      :class="{
                        'is-invalid': errors.has('pdt_detail_id'),
                        'mr-3 table-form-search': true,
                        product_search: true,
                      }"
                      :serializer="
                        (product) =>
                          product.label +
                          ' ' +
                          product.pdt_legacy_id +
                          ' ' +
                          product.pdt_sku
                      "
                      @hit="checkSalePrice($event, index, 'goods_items')"
                      placeholder="Type to search product"
                      :ref="'pdt_name_typeahead_' + 'goods_items' + index"
                    />

                    <b-button
                      variant="light"
                      size="xs"
                      v-b-tooltip
                      title="Add Product"
                      v-if="RoutePermission(false, '', '', 'product', 'create')"
                      @click="
                        (item_id = index), addNewProduct(index, 'goods_items')
                      "
                    >
                      <i class="la la-plus"></i>
                    </b-button>
                  </span>
                  <b-form-input
                    v-show="false"
                    type="text"
                    size="sm"
                    :name="'pdt_id[' + index + ']'"
                    :data-vv-name="'row ' + (index + 1) + ' product'"
                    v-model.trim="item.pdt_id"
                    v-validate="'required'"
                  />
                  <!--
                        HSN/SAC code
                        <small class="text-link">
                          HSN / SAC:
                          <input
                          :data-vv-name="'row '+(index +1)+' HSN/SAC'"
                            v-validate="'max:8|numeric'"
                            type="text"
                            :name="'pdt_hsn['+index+']'"
                            v-model.trim="item.pdt_hsn"
                            style="border:none;background-color:rgb(247, 247, 247)"
                          />
                  </small>-->
                  <!-- Description -->
                  <!-- <textarea
                    :data-vv-name="'row '+(index +1)+' description'"
                          v-validate="'max:255'"
                          class="form-control mt-1 item_table_desc"
                          :name="'pdt_desc['+index+']'"
                          v-model.trim="item.pdt_desc"
                          rows="3"
                  ></textarea>-->
                </td>
                <!-- Product quantity -->
                <td>
                  <input
                    :data-vv-name="'row ' + (index + 1) + ' product quantity'"
                    v-model.trim="item.pdt_qty"
                    :name="'pdt_qty[' + index + ']'"
                    @blur="roundOffLineItem(index, 'pdt_qty', 6, 'goods_items')"
                    v-validate="
                      (item.pdt_cat == 2 ? 'numeric|' : '') +
                      'required|min_value:0|max_value:100000000000000'
                    "
                    :class="{
                      'form-control': true,
                      'is-invalid': errors.has('pdt_qty'),
                    }"
                    type="text"
                    id="pdt_qty"
                    class="text-right"
                  />
                  <small class="float-right text-link"></small>
                </td>
                <!-- Selling price -->
                <td>
                  <b-form-input
                    type="text"
                    :disabled="true"
                    id="selling_price"
                    class="text-right"
                    :name="'sale_price[' + index + ']'"
                    :data-vv-name="'row ' + (index + 1) + ' sales price'"
                    v-model.trim="item.sale_price"
                  />
                </td>
                <!-- Purchase price -->
                <!-- Icon for remove row -->
                <td>
                  <i
                    class="glyphicon glyphicon-trash"
                    @click="removeRow(index, 'goods_items')"
                  ></i>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td style="border: 0 !important">
                  <span
                    @click="addNewRow('goods_items')"
                    class="addline text-link cursor_pointer"
                    >Add Lines</span
                  >
                  <span
                    v-if="service_items.length == 0"
                    @click="addNewRow('service_items')"
                    class="ml-2 addline text-link cursor_pointer"
                    >| Add Service Products</span
                  >

                  <span class="float-right fw-semi-bold">Total</span>
                </td>
                <td
                  class="fw-semi-bold text-right pr-3"
                  style="border: 0 !important"
                >
                  {{ Number(total("goods_items").totalQty) }}
                </td>
                <td
                  class="fw-semi-bold text-right pr-3"
                  style="border: 0 !important"
                >
                  {{ orgCurrencySymbol }}
                  {{
                    Number(total("goods_items").total).toLocaleString(
                      undefined,
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row
        style="max-width: 1000px"
        class="mt-5"
        v-if="service_items.length > 0"
      >
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <p>
            Associate Services
            <span class="text-danger">*</span>
          </p>
          <!-- Table for amcservice products -->
          <table
            class="table table-bordered sales-table last-child-border-none total-table"
          >
            <thead>
              <!-- <th width="1%"></th> -->
              <th width="30%">Product details</th>
              <!-- <th>Description</th> -->
              <th width="10%" class="text-right">Quantity</th>
              <th width="10%" class="text-right">
                Selling Price ( {{ orgCurrency }} )
              </th>
              <th width="1%"></th>
            </thead>
            <tbody>
              <!-- Product index -->
              <tr v-for="(item, index) in service_items" :key="index">
                <!-- <td>{{ index + 1 }}</td> -->
                <td
                  @click="removeproduct($event, index, 'service_items')"
                  class="show-product-details"
                >
                  <!-- Product search -->
                  <span class="d-flex">
                    <vue-bootstrap-typeahead
                      style="width: 100%"
                      @input="productlist($event, index, 'service_items')"
                      v-model="item.pdt_detail_id"
                      :id="'vuebootsearcher' + 'service_items' + index"
                      name="pdt_detail_id[]"
                      :data="item.products"
                      :class="{
                        'is-invalid': errors.has('pdt_detail_id'),
                        'mr-3 table-form-search': true,
                        product_search: true,
                      }"
                      :serializer="
                        (product) =>
                          product.label +
                          ' ' +
                          product.pdt_legacy_id +
                          ' ' +
                          product.pdt_sku
                      "
                      @hit="checkSalePrice($event, index, 'service_items')"
                      placeholder="Type to search product"
                      :ref="'pdt_name_typeahead_' + 'service_items' + index"
                    />

                    <b-button
                      variant="light"
                      size="xs"
                      v-b-tooltip
                      title="Add Product"
                      v-if="RoutePermission(false, '', '', 'product', 'create')"
                      @click="
                        (item_id = index), addNewProduct(index, 'service_items')
                      "
                    >
                      <i class="la la-plus"></i>
                    </b-button>
                  </span>
                  <b-form-input
                    v-show="false"
                    type="text"
                    size="sm"
                    :name="'pdt_id[' + index + ']'"
                    :data-vv-name="'row ' + (index + 1) + ' product'"
                    v-model.trim="item.pdt_id"
                    v-validate="'required'"
                  />
                  <!--
                        HSN/SAC code
                        <small class="text-link">
                          HSN / SAC:
                          <input
                          :data-vv-name="'row '+(index +1)+' HSN/SAC'"
                            v-validate="'max:8|numeric'"
                            type="text"
                            :name="'pdt_hsn['+index+']'"
                            v-model.trim="item.pdt_hsn"
                            style="border:none;background-color:rgb(247, 247, 247)"
                          />
                  </small>-->
                  <!-- Description -->
                  <!-- <textarea
                    :data-vv-name="'row '+(index +1)+' description'"
                          v-validate="'max:255'"
                          class="form-control mt-1 item_table_desc"
                          :name="'pdt_desc['+index+']'"
                          v-model.trim="item.pdt_desc"
                          rows="3"
                  ></textarea>-->
                </td>
                <!-- Product quantity -->
                <td>
                  <input
                    :data-vv-name="'row ' + (index + 1) + ' product quantity'"
                    v-model.trim="item.pdt_qty"
                    :name="'pdt_qty[' + index + ']'"
                    @blur="
                      roundOffLineItem(index, 'pdt_qty', 6, 'service_items')
                    "
                    v-validate="
                      (item.pdt_cat == 2 ? 'numeric|' : '') +
                      'required|min_value:0|max_value:100000000000000'
                    "
                    :class="{
                      'form-control': true,
                      'is-invalid': errors.has('pdt_qty'),
                    }"
                    type="text"
                    id="pdt_qty"
                    class="text-right"
                  />
                  <small class="float-right text-link"></small>
                </td>
                <!-- Selling price -->
                <td>
                  <b-form-input
                    type="text"
                    :disabled="true"
                    id="selling_price"
                    class="text-right"
                    :name="'sale_price[' + index + ']'"
                    :data-vv-name="'row ' + (index + 1) + ' sales price'"
                    v-model.trim="item.sale_price"
                  />
                </td>
                <!-- Purchase price -->
                <!-- Icon for remove row -->
                <td>
                  <i
                    class="glyphicon glyphicon-trash"
                    @click="removeRow(index, 'service_items')"
                  ></i>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td style="border: 0 !important">
                  <span
                    @click="addNewRow('service_items')"
                    class="addline text-link cursor_pointer"
                    >Add Lines</span
                  >
                  <span
                    v-if="goods_items.length == 0"
                    @click="addNewRow('goods_items')"
                    class="ml-2 addline text-link cursor_pointer"
                    >| Add Goods Products</span
                  >
                  <span class="float-right fw-semi-bold">Total</span>

                  <span class="float-right fw-semi-bold">Total</span>
                </td>
                <td
                  class="fw-semi-bold text-right pr-3"
                  style="border: 0 !important"
                >
                  {{ Number(total("service_items").totalQty) }}
                </td>
                <td
                  class="fw-semi-bold text-right pr-3"
                  style="border: 0 !important"
                >
                  {{ orgCurrencySymbol }}
                  {{
                    Number(total("service_items").total).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row style="max-width: 1000px">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label-for="rate">
            <template slot="label">
              Sales Price
              <span class="text-danger">*</span>
              <span
                @click="copyFromTotal('selling')"
                class="text-sm text-primary float-right cursor_pointer"
                >Copy from total</span
              >
            </template>

            <b-input-group
              :prepend="orgCurrency"
              class="mb-2 mr-sm-2 mb-sm-0 product_currency"
            >
              <input
                @blur="roundOffItem('pdt_sal_price', 6)"
                type="text"
                size="sm"
                class="form-control"
                name="pdt_sal_price"
                data-vv-name="sales price"
                v-model.trim="field.pdt_sal_price"
                v-validate="'required|max_value:100000000000000'"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width: 1000px" class="mt-2">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            v-if="org_details.gst_type == 1"
            class="mb-3"
            label-cols="4"
            horizontal
            label-class="required"
            label="Tax Preference"
            label-for="tax"
          >
            <b-form-radio-group
              @input="
                (field.pdt_inter_tax_id =
                  field.tax_preference_value == '0'
                    ? {
                        label: 'Non Taxable',
                        value: '20',
                        sales_tax_percent: '0.00',
                      }
                    : ''),
                  (field.pdt_tax_id =
                    field.tax_preference_value == '0'
                      ? {
                          label: 'Non Taxable',
                          value: '19',
                          sales_tax_percent: '0.00',
                        }
                      : '')
              "
              @change="field.exempt_reason = ''"
              class="mt-1"
              id="tax_preference_value"
              :options="taxable_preference"
              name="tax_preference_value"
              data-vv-name="tax preference"
              v-model.trim="field.tax_preference_value"
              v-validate="'required'"
            />
          </b-form-group>
          <b-form-group
            class="mb-3"
            label-class="required"
            label="Exempt Reason"
            label-for="exempt_reason"
            v-if="field.tax_preference_value == '0'"
          >
            <b-input-group class="vselect-custom-add">
              <template slot="append">
                <b-input-group-text
                  class="vselect-custom-add-icon"
                  v-b-tooltip
                  title="Add Exempt"
                  v-on:click="
                    (excemptbundlemodal = true),
                      callexemptmodal({ value: '', label: '' })
                  "
                  >&#43;</b-input-group-text
                >
              </template>
              <template slot="prepend">
                <v-select
                  :clearable="false"
                  size="sm"
                  :options="exempt_reason_list"
                  label="label"
                  index="value"
                  name="exempt_reason"
                  data-vv-name="exempt reason"
                  v-model.trim="field.exempt_reason"
                  v-validate="'required'"
                  placeholder="Exempt reason"
                  class="form-vselect"
                >
                  <template slot="option" slot-scope="option">
                    <div
                      class="d-flex w-100 v-select-option"
                      :title="option.label"
                    >
                      <div class="text-truncate" style="width: 292px">
                        {{ option.label }}
                      </div>
                      <span class="select-hover-block">
                        <span
                          class="la la-edit la-lg float-right mr-2"
                          v-on:click.stop="
                            (excemptbundlemodal = true),
                              callexemptmodal({
                                value: option.value,
                                label: option.label,
                              })
                          "
                        ></span>
                        <span
                          class="fa fa-trash-o fa-lg float-right mt-2p"
                          v-on:click.stop="
                            (excemptbundledelete = true),
                              (method = 'exemptdelete'),
                              (types = 'exempt'),
                              calldeletemodal(option.value)
                          "
                        ></span>
                      </span>
                    </div>
                  </template>
                </v-select>
              </template>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        style="max-width: 1000px"
        v-if="field.tax_preference_value == '1' && org_details.gst_type == 1"
      >
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Inter state Tax '"
            label-class="required"
            label-for="basic"
          >
            <v-select
              :clearable="false"
              @input="inter_tax_id($event)"
              name="pdt_inter_tax_id"
              data-vv-name="inter state tax"
              v-model.trim="field.pdt_inter_tax_id"
              v-validate="'required'"
              :options="
                igst_tax
                  .map((igstTax) => ({
                    label: igstTax.tax_name,
                    value: igstTax.tax_id,
                    sales_tax_percent: igstTax.sales_tax_percent,
                  }))
                  .filter((x) => x.value != 20)
              "
            ></v-select>

            <span
              style="position: relative; top: 5px"
              v-if="
                field.pdt_tax_type_value == 1 && field.pdt_inter_tax_id != ''
              "
            >
              <small>
                <p class="mb-1 pb-0">
                  Unit Price -
                  {{
                    parseFloat(
                      inclusiveAmount().pdt_incl_inter_price
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </p>
              </small>
            </span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Intra state Tax '"
            label-class="required"
            label-for="basic"
          >
            <v-select
              :clearable="false"
              @input="intra_tax_id($event)"
              name="pdt_tax_id"
              data-vv-name="intra state tax"
              v-model.trim="field.pdt_tax_id"
              size="sm"
              v-validate="'required'"
              :options="
                local_tax
                  .map((local_tax) => ({
                    label: local_tax.tax_name,
                    value: local_tax.tax_id,
                    sales_tax_percent: local_tax.sales_tax_percent,
                  }))
                  .filter((x) => x.value != 19)
              "
            ></v-select>
            <span
              style="position: relative; top: 5px"
              v-if="field.pdt_tax_type_value == 1 && field.pdt_tax_id != ''"
            >
              <small>
                <p class="mb-1 pb-0">
                  Unit Price -
                  {{
                    parseFloat(
                      inclusiveAmount().pdt_incl_intra_price
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </p>
              </small>
            </span>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row style="max-width: 1000px" class="mt-1">
        <b-col cols="12" lg="5" md="6" sm="8" v-if="org_details.gst_type == 1">
          <b-form-checkbox
            v-if="field.tax_preference_value == '1'"
            id="pdt_tax_type_value"
            v-model.trim="field.pdt_tax_type_value"
            name="pdt_tax_type_value"
            value="1"
            unchecked-value="0"
            >Inclusive of tax</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
            v-b-toggle.product-informations
          >
            Product Informations
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="product-informations" visible>
        <b-row style="max-width: 1000px">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              label="SKU"
              label-for="basic"
              class="mb-3"
              :label-class="allow_duplicate_pdt ? 'required' : ''"
              v-if="pdt_sku"
            >
              <input
                v-model.trim="field.pdt_sku"
                v-validate="
                  allow_duplicate_pdt ? 'required|max:200' : 'max:200'
                "
                name="pdt_sku"
                :class="{ 'form-control': true }"
                type="text"
                id="pdt_sku"
                data-vv-name="SKU"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="HSN/SAC Code" label-for="basic" v-if="pdt_hsn">
              <input
                name="HSN/SAC"
                v-model.trim="field.pdt_hsn"
                :class="{ 'form-control': true }"
                type="text"
                id="pdt_hsn"
                data-vv-name="HSN/SAC"
                v-validate="'max:8|numeric'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Legacy Id" label-for="basic" class="mb-3">
              <input
                v-model.trim="field.pdt_legacy_id"
                name="pdt_legacy_id"
                :class="{ 'form-control': true }"
                type="text"
                id="pdt_legacy_id"
                data-vv-name="legacy id"
                v-validate="'max:15'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              label="Account"
              label-for="account"
              label-class="required"
            >
              <select
                v-model.trim="field.pdt_sales_account"
                v-chosen="field.pdt_sales_account"
                name="Account"
                data-vv-name="Account"
                v-validate="'required'"
                class="chosen v-select form-control"
              >
                <optgroup
                  :label="item.gl_acc_type"
                  v-for="item in sales_account"
                  :key="item.id"
                >
                  <option
                    v-for="acc in acc_types"
                    :key="acc.id"
                    v-if="acc.gl_acc_type_id == item.gl_acc_type_id"
                    :value="acc.gl_acc_id"
                  >
                    {{ acc.gl_acc_name }}
                  </option>
                </optgroup>
              </select>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="10">
            <b-form-group
              label="Product Tags"
              label-for="product-tag-select"
              class="mb-3"
            >
              <b-input-group class="vselect-custom-add">
                <template slot="append">
                  <b-input-group-text
                    class="vselect-custom-add-icon"
                    v-b-tooltip
                    title="Add Product Tags"
                    v-on:click="
                      (bundletagmodal = true),
                        (updatetag = false),
                        calltagmodal({ tag_id: '', tag_name: '' })
                    "
                    >&#43;</b-input-group-text
                  >
                </template>
                <template slot="prepend">
                  <v-select
                    :clearable="false"
                    multiple
                    size="sm"
                    :options="producttaglist"
                    label="label"
                    index="value"
                    id="tags-select"
                    v-model.trim="field.pdt_tags"
                  >
                    <template slot="option" slot-scope="option">
                      <div
                        class="d-flex w-100 v-select-option"
                        :title="option.label"
                      >
                        <div class="text-truncate" style="width: 92%">
                          {{ option.label }}
                        </div>
                        <span class="select-hover-block">
                          <span
                            class="la la-edit la-lg float-right mr-2"
                            v-on:click.prevent="
                              (bundletagmodal = true),
                                (updatetag = true),
                                calltagmodal({
                                  tag_id: option.value,
                                  tag_name: option.label,
                                })
                            "
                          ></span>
                          <span
                            class="fa fa-trash-o fa-lg float-right mt-2p"
                            v-on:click.stop="
                              (bundletagdelete = true),
                                (types = 'pdtdelete'),
                                (method = 'producttagdelete'),
                                calldeletemodal(option.value)
                            "
                          ></span>
                        </span>
                      </div>
                    </template>
                  </v-select>
                </template>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width: 1000px" class="mt-2">
          <b-col cols="12" lg="10">
            <b-form-group
              label="Product Description"
              label-for="default-textarea"
              class="mb-3"
            >
              <b-form-textarea
                :rows="4"
                name="pdt_desc"
                v-model.trim="field.pdt_desc"
                data-vv-name="product description"
                v-validate="'min:3|max:250'"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>
      <b-row
        style="max-width: 1000px"
        class="mt-4 mb-2 pt-2"
        v-if="pdt_settings_details.custom_field.length > 0"
      >
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
            v-b-toggle.collapse-1
          >
            Custom Fields
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>

      <b-collapse id="collapse-1" visible>
        <b-row style="max-width: 1000px">
          <b-col
            cols="6"
            lg="5"
            md="6"
            sm="8"
            :key="index"
            v-for="(custom_field, index) in pdt_settings_details.custom_field"
            v-if="custom_field.status == 1 && custom_field.permissions == 'write'"
          >
            <CustomPreview
              v-on:assigncustomvalue="assigncustomvalue($event)"
              :custom="custom_field"
              :disabled="false"
              :modelname="field[custom_field.field_name]"
            />
            <input
              type="hidden"
              :data-vv-name="custom_field.label_name"
              :name="custom_field.label_name"
              v-validate="custom_field.validation"
              v-model="field[custom_field.field_name]"
            />
          </b-col>
        </b-row>
      </b-collapse>

      <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
            v-b-toggle.reporting-tags
          >
            Reporting Tags
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="reporting-tags" visible>
        <b-row style="max-width: 1000px">
          <!-- Billing Address details tab -->
          <b-col v-if="reporting_tags.length == 0">
            <p class="text-muted">You've not created any Reporting Tags.</p>
          </b-col>
          <b-col
            v-else-if="
              reporting_tags.filter(
                (tag) =>
                  (tag.status === '0' && field[tag.tag_column_name] != '') ||
                  tag.status === '1'
              ).length == 0
            "
          >
            <p class="text-muted">
              There are no active reporting tags or you've not created a
              reporting tag yet.You can create/edit reporting tags under
              settings
            </p>
          </b-col>
          <template v-else>
            <b-col
              cols="12"
              lg="5"
              md="6"
              sm="8"
              v-for="(tag, index) in reporting_tags"
              :key="index"
              v-if="tag.status === '1' || show_reporting_tag[index].used"
            >
              <b-form-group
                :label-for="'tag field' + index"
                :label="tag.tag_name"
                label-class="text-truncate"
                v-if="
                  tag.tag_options.filter(
                    (x) =>
                      (x.is_active == false &&
                        show_reporting_tag[index][tag.tag_column_name] ==
                          x.value) ||
                      x.is_active
                  ).length > 0
                "
              >
                <v-select
                  :clearable="
                    field[tag.tag_column_name] != '' &&
                    field[tag.tag_column_name] != null
                  "
                  @input="
                    $event == null ? (field[tag.tag_column_name] = '') : ''
                  "
                  v-model="field[tag.tag_column_name]"
                  index="value"
                  label="label"
                  :options="
                    tag.tag_options.filter(
                      (x) =>
                        (x.is_active == false &&
                          show_reporting_tag[index][tag.tag_column_name] ==
                            x.value) ||
                        x.is_active
                    )
                  "
                  class="form-vselect"
                >
                  <template slot="option" slot-scope="option">
                    <div
                      class="d-flex w-100 v-select-option"
                      :title="option.label"
                    >
                      <div class="text-truncate" style="width: 100%">
                        {{ option.label }}
                      </div>
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </template>
        </b-row>
      </b-collapse>

      <div class="footer" style="box-shadow: 0 -4px 5px -3px #ccc">
        <div :class="{ 'form-action': true }">
          <b-button
            type="submit"
            :variant="page == 'update' ? 'primary' : 'primary'"
            class="btn-rounded mr-3 btn-sm"
            :disabled="submitted"
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>
            {{ page == "update" ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
    <TagModal
      v-if="bundletagmodal"
      :tag_id="modal_tag_id"
      module="products"
      v-on:setMultipleAddedRef="getMultipleAddedRef"
    ></TagModal>
    <ExemptReason
      v-if="excemptbundlemodal"
      :exempt_reason="modal_exempt_reason"
      module="products"
      v-on:setMultipleAddedRefExempt="getMultipleAddedRefExempt"
    ></ExemptReason>
    <DeleteDropdown
      v-if="bundletagdelete || excemptbundledelete"
      id="bundle-dropdown-delete"
      content="Are you sure to delete selected detail?"
      module="general"
      :types="types"
      :method="method"
      v-on:setDropdownDelete="getDropdownDelete"
      :value="deletedropdownid"
    ></DeleteDropdown>
    <!-- Call product modal -->
    <ProductModal
      v-if="item_id != '' || item_id === 0"
      v-on:setProductValue="getProductValue($event, newPdt.pdt_state)"
      v-on:closeModal="closePdtModal()"
      module="amcservice"
      :pdttype="'sales'"
      :pdtStateDisable="true"
      :pdtStateId="newPdt.pdt_state_id"
      :itemId="item_id"
    ></ProductModal>
  </div>
</template>
<!--script for amcservice create pages -->
<script>
// import all the components, files and funciton
import getPageTitle from "@/utils/get-page-title"; // to set page title
import VueBootstrapTypeahead from "vue-bootstrap-typeahead"; // data on search api calls
import ProductModal from "@/components/Modal/ProductModal"; // product modal
import { mapState, mapGetters } from "vuex";
import vSelect from "vue-select";
import TagModal from "@/components/Modal/TagModal";
import ExemptReason from "@/components/Modal/ExemptReason";
import $ from "jquery";
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import DeleteDropdown from "@/components/Modal/DeleteDropdown";

export default {
  props: ["page", "submitted", "duplicatecode"],
  name: "ProductCreate",
  components: {
    VueBootstrapTypeahead,
    vSelect,
    TagModal,
    ProductModal, // product create modal
    DeleteDropdown,
    ExemptReason,
    CustomPreview,
  },
  data() {
    return {
      show_reporting_tag: [],
      reportTagCollapse: "",
      bundletagmodal: false,
      updatetag: false,
      bundletagdelete: false,
      excemptbundlemodal: false,
      excemptbundledelete: false,
      method: "",
      types: "",
      intra_sales_tax_percent: "",
      inter_sales_tax_percent: "",
      pdt_hsn: "",
      pdt_sku: "",
      totalQty: 0,
      total_purchase: 0,
      update_price: false, // update input after one bind
      deletedropdownid: "",
      modal_tag_id: {},
      index: [],
      products: [],
      item_id: "", // item id for product create modal
      old_goods_composite_itm_ids: "",
      old_service_composite_itm_ids: "",
      field: this.createFreshEventObject(), // header detail data initialize
      error_show: false, // to show the error message
      modal_exempt_reason: "",
      taxable_preference: [
        {
          text: "Taxable",
          value: "1",
        },
        {
          text: "Tax Exempt",
          value: "0",
        },
      ],
      goods_items: [
        {
          composite_id: "",
          pdt_hsn: "",
          unit_name: "",
          pdt_desc: "",
          pdt_detail_id: "",
          products: [],
          pdt_id: "",
          pdt_qty: 1,
          unit_price: 0,
          pur_unit_price: 0,
          sale_price: 0,
          purchase_price: 0,
          pdt_state: 1,
          pdt_type: 1,
        },
      ],
      service_items: [],
      newPdt: {
        pdt_state_id: "",
        pdt_state: "",
      },
    };
  },
  methods: {
    redirectPage(){
              if(this.$route.query.page_from=='view'&&(this.$route.params.id||this.$route.query.clone_id||this.$route.query.old_id)){
                this.$router.push({name:'AmcServiceView',params:{id:this.$route.params.id||this.$route.query.clone_id||this.$route.query.old_id}})}
              else {
        if (this.$store.state.amcservice.bundle_index_history) {
          this.$router.push(this.$store.state.amcservice.bundle_index_history);
        }

              else{
                this.$router.push({name:'AmcService'})
              }
              }
    },
    closePdtModal() {
      this.item_id = "";
      this.newPdt = {
        pdt_state_id: "",
        pdt_state: "",
      };
    },
    async addNewProduct(index, state) {
      this.newPdt = await {
        pdt_state_id: state == "goods_items" ? 1 : 2,
        pdt_state: state,
      };
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "createproduct");
      });
    },
    copyFromTotal(ev) {
      var goods_total = this.total("goods_items");
      var service_total = this.total("service_items");
      if (ev == "selling") {
        this.field.pdt_sal_price = parseFloat(
          parseFloat(goods_total.total) + parseFloat(service_total.total)
        );
      } else {
        this.field.pdt_pur_price = parseFloat(
          parseFloat(goods_total.total_purchase) +
            parseFloat(service_total.total_purchase)
        );
      }
    },

    //  assign custom value
    assigncustomvalue(ev) {
      this.field[ev.field] = ev.value;
    },

    intra_tax_id(ev) {
      this.intra_sales_tax_percent = ev.sales_tax_percent;
    },
    inter_tax_id(ev) {
      this.inter_sales_tax_percent = ev.sales_tax_percent;
    },
    inclusiveAmount() {
      var pdt_pur_incl_inter_price = 0;
      var pdt_pur_incl_intra_price = 0;
      var pdt_incl_intra_price = 0;
      var pdt_incl_inter_price = 0;
      if (
        this.field.pdt_tax_type_value == 1 &&
        (this.field.pdt_sal_price > 0 || this.field.pdt_pur_price > 0)
      ) {
        pdt_incl_intra_price = this.pdt_incl_inter_price = parseFloat(
          parseFloat(this.field.pdt_sal_price) /
            (1 + parseFloat(this.intra_sales_tax_percent) / 100)
        ).toFixed(2);
        pdt_incl_inter_price = this.pdt_incl_inter_price = parseFloat(
          parseFloat(this.field.pdt_sal_price) /
            (1 + parseFloat(this.inter_sales_tax_percent) / 100)
        ).toFixed(2);
        pdt_pur_incl_intra_price = this.pdt_pur_incl_inter_price = parseFloat(
          parseFloat(this.field.pdt_pur_price) /
            (1 + parseFloat(this.intra_sales_tax_percent) / 100)
        ).toFixed(2);
        pdt_pur_incl_inter_price = this.pdt_pur_incl_inter_price = parseFloat(
          parseFloat(this.field.pdt_pur_price) /
            (1 + parseFloat(this.inter_sales_tax_percent) / 100)
        ).toFixed(2);
      }
      this.field.pdt_incl_intra_price =
        isNaN(pdt_incl_intra_price) ||
        pdt_incl_intra_price == "" ||
        pdt_incl_intra_price == null ||
        typeof pdt_incl_intra_price == "undefined"
          ? 0
          : parseFloat(pdt_incl_intra_price);
      this.field.pdt_incl_inter_price =
        isNaN(pdt_incl_inter_price) ||
        pdt_incl_inter_price == "" ||
        pdt_incl_inter_price == null ||
        typeof pdt_incl_inter_price == "undefined"
          ? 0
          : parseFloat(pdt_incl_inter_price);
      this.field.pdt_pur_incl_intra_price =
        isNaN(pdt_pur_incl_intra_price) ||
        pdt_pur_incl_intra_price == "" ||
        pdt_pur_incl_intra_price == null ||
        typeof pdt_pur_incl_intra_price == "undefined"
          ? 0
          : parseFloat(pdt_pur_incl_intra_price);
      this.field.pdt_pur_incl_inter_price =
        isNaN(pdt_pur_incl_inter_price) ||
        pdt_pur_incl_inter_price == "" ||
        pdt_pur_incl_inter_price == null ||
        typeof pdt_pur_incl_inter_price == "undefined"
          ? 0
          : parseFloat(pdt_pur_incl_inter_price);
      return {
        pdt_incl_intra_price: pdt_incl_intra_price,
        pdt_incl_inter_price: pdt_incl_inter_price,
        pdt_pur_incl_inter_price: pdt_pur_incl_inter_price,
        pdt_pur_incl_intra_price: pdt_pur_incl_intra_price,
      };
    },
    //  get the product created in modal and selected in dropdown
    getProductValue(event, state) {
      var index = event[0].index;
      var values = event[0];
      $("#vuebootsearcher" + state + index + " input").removeClass("mask");
      $("#vuebootsearcher" + state + index + " .input-group .remover").remove();
      var pdt_name = "pdt_name_typeahead_" + state + index;
      this.$refs[pdt_name][0].inputValue = event[0].label;
      this[state][index].pdt_qty = 1;
      this[state][index].pdt_id = event[0].value;
      this[state][index].products = event;
      //  pass the details to sales rprice modal
      this.checkSalePrice(
        {
          value: values.value,
          label: values.label,
          pdt_sal_price: values.pdt_sal_price,
          pdt_pur_price: values.pdt_pur_price,
          pdt_tax_id: values.pdt_tax_id,
          pdt_inter_tax_id: values.pdt_inter_tax_id,
          pdt_hsn: values.pdt_hsn,
          pdt_desc: values.pdt_desc,
          unit_name: values.unit_name,
          pdt_cat: values.pdt_cat,
          pdt_type: values.pdt_type,
        },
        index,
        state
      );
    },
    callexemptmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addexempt");
        this.modal_exempt_reason = val;
      });
    },
    checkSalePrice(event, index, state) {
      $("#vuebootsearcher" + state + index + " input").addClass("mask");
      $("#vuebootsearcher" + state + index + " .input-group").append(
        "<span class='la la-close p-2 mt-1 remover'></span>"
      );
      if (this.update_price == true) {
        if (event.value != null) {
          var pdt_name = "pdt_name_typeahead_" + state + index;
          this.$refs[pdt_name][0].inputValue = event.label;
          this[state][index].pdt_id = event.value; // assing the selcted product id to pdt_id modal
          this[state][index].unit_price = event.pdt_sal_price; // get unit price of the selected product
          this[state][index].pur_unit_price = event.pdt_pur_price; // get unit price of the selected product
          this[state][index].pdt_hsn = event.pdt_hsn; // get the pdt hsn of the selected product
          this[state][index].unit_name = event.unit_name; // get the pdt hsn of the selected product
          this[state][index].pdt_desc = event.pdt_desc; // get the pdt hsn of the selected product
          this[state][index].pdt_cat = event.pdt_cat;
          this[state][index].pdt_type = event.pdt_type;
        }
      }
    },
    getMultipleAddedRefExempt(ev) {
      if (ev.close) {
        this.excemptbundlemodal = false;
        return;
      }
      this.field.exempt_reason = "";

      this.field.exempt_reason = this.updatedtag_id;
    },
    getMultipleAddedRef(ev) {
      if (ev.close) {
        this.bundletagmodal = false;
        return;
      }
      var value = this.updatedtag_id;
      if (this.updatetag != true) {
        this.field.pdt_tags.push(value);
      }
    },
    //  get the product details on search
    productlist(event, index, state) {
      if (event != "") {
        this.$store
          .dispatch(
            "general/fetchProductData",
            JSON.stringify({
              field: event,
              type: state == "goods_items" ? "goods" : "service",
            })
          )
          .then(() => {
            this[state][index].products = this.product_filter_list;
          });
      }
    },
    getDropdownDelete(ev) {
      if (ev.close) {
        this.bundletagdelete = false;
        this.excemptbundledelete = false;
        return;
      }
      if (ev == 200) {
        if (this.method == "producttagdelete") {
          if (this.field.pdt_tags != "") {
            var index = this.field.pdt_tags.indexOf(this.deletedropdownid);
            if (index != -1) {
              this.field.pdt_tags.splice(index, 1);
              this.deletedropdownid = "";
            }
          }
        } else if (this.method == "exemptdelete") {
          var id = this.getPresentValue(
            this.exempt_reason_list,
            "label",
            ev.label,
            "value"
          );
          this.field.exempt_reason = id;
        }
      }
    },
    calldeletemodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "bundle-dropdown-delete");
        this.deletedropdownid = val;
      });
    },

    //  to get the json particular value
    getPresentValue(arr, prop, val, field) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][field];
          // alert(hasMatch);
          break;
        }
      }
      return hasMatch;
    },
    //  for rounding off total maount modal
    roundOffItem(field, digits) {
      var digit = parseInt(digits);
      if (!(this.field[field] === "")) {
        this.field[field] =
          typeof this.field[field] != undefined && !isNaN(this.field[field])
            ? parseFloat(parseFloat(this.field[field]).toFixed(digit))
            : parseFloat(parseFloat(0).toFixed(digit));
      }
    },
    roundOffLineItem(index, field, digits, state) {
      var digit = parseInt(digits);
      if (!(this[state][index][field] === "")) {
        this[state][index][field] =
          typeof this[state][index][field] != undefined &&
          !isNaN(this[state][index][field])
            ? parseFloat(parseFloat(this[state][index][field]).toFixed(digit))
            : parseFloat(parseFloat(0).toFixed(digit));
      }
    },
    roundOffvalue() {
      this.field.pdt_tax_type_value =
        this.field.tax_preference_value == "0"
          ? "0"
          : this.field.pdt_tax_type_value;
    },
    calltagmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addTag");
        this.modal_tag_id = val;
      });
    },
    //To remove row
    removeRow(index, state) {
      if (this[state].length > 1) {
        var i;
        if (typeof this[state][parseInt(index) + 1] != "undefined") {
          for (i = index; i < this[state].length - 1; i++) {
            var pdt_name = "pdt_name_typeahead_" + state + i;
            this.$refs[pdt_name][0].inputValue = this[state][
              i + 1
            ].pdt_detail_id;
            if (this[state][i + 1].pdt_detail_id == "") {
              $("#vuebootsearcher" + state + i + " input").css(
                "pointer-events",
                "all"
              );
              $("#vuebootsearcher" + state + i + " input").css(
                "background-color",
                "#fff"
              );
              $("#vuebootsearcher" + state + i + " input").css("position", "");
              $("#product_remove_" + i).remove();
            }
          }
        }
        this[state].splice(index, 1);
      } else if (
        (state == "goods_items" && this.service_items.length!=0&&
          this.pdt_settings_details.allow_service_only_bundle == 1) ||
        (state == "service_items" && this.goods_items.length!=0)
      ) {
        this[state] = [];
      }
    },
    //Remove product
    removeproduct(e, index, state) {
      if (e.target.matches(".remover")) {
        $("#vuebootsearcher" + state + index + " input").removeClass("mask");
        $(
          "#vuebootsearcher" + state + index + " .input-group .remover"
        ).remove();
        var pdt_name = "pdt_name_typeahead_" + state + index;
        this.$refs[pdt_name][0].inputValue = "";
        this[state][index].pdt_id = "";
        this[state][index].pdt_desc = "";
        this[state][index].pdt_qty = 1;
        this[state][index].unit_price = 0;
        this[state][index].pur_unit_price = 0;
        this[state][index].pdt_hsn = "";
        this[state][index].sale_price = 0;
        this[state][index].purchase_price = 0;
      }
    },
    //onsubmit process
    onSubmit(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          //  send the json data
          var data = JSON.stringify({
            field: this.field,
            goods_items: this.goods_items,
            service_items: this.service_items,
            old_goods_composite_itm_ids: this.old_goods_composite_itm_ids,
            old_service_composite_itm_ids: this.old_service_composite_itm_ids,
          });
          this.$emit("onSubmit", data);
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // validate the form if fail
        }
      });
    },
    //add new row
    addNewRow(state) {
      this[state].push({
        composite_id: "",
        pdt_hsn: "",
        unit_name: "",
        pdt_desc: "",
        pdt_detail_id: "",
        products: [],
        pdt_id: "",
        pdt_qty: 1,
        sale_price: 0,
        purchase_price: 0,
        unit_price: 0,
        pur_unit_price: 0,
        pdt_state: state == "goods_items" ? 1 : 2,
        pdt_type: 1,
      });
    },
    total(state) {
      //  calculating the total without tax
      var totalQty = parseFloat(this.totalQty);
      var total_purchase = parseFloat(this.total_purchase);
      var total = this[state].reduce(function (total, value) {
        if (value.pdt_id != "") {
          //  get pdt qty
          var pdt_qty =
            !isNaN(value.pdt_qty) && value.pdt_qty != ""
              ? parseFloat(value.pdt_qty)
              : 0;
          var pur_unit_price =
            !isNaN(value.pur_unit_price) && value.pur_unit_price != ""
              ? parseFloat(value.pur_unit_price)
              : 0;
          totalQty += parseFloat(pdt_qty);
          value.purchase_price = parseFloat(
            parseFloat(pdt_qty) * parseFloat(value.pur_unit_price)
          ).toFixed(2);
          total_purchase =
            parseFloat(total_purchase) +
            parseFloat(pdt_qty) * parseFloat(pur_unit_price);
          value.sale_price = parseFloat(
            parseFloat(pdt_qty) * parseFloat(value.unit_price)
          ).toFixed(2);
        }
        return !isNaN(parseFloat(value.sale_price))
          ? total + parseFloat(value.sale_price)
          : parseFloat(total);
      }, 0);
      return {
        total: total.toFixed(2),
        totalQty: totalQty.toFixed(2),
        total_purchase: total_purchase.toFixed(2),
      };
    },
    createFreshEventObject() {
      return {
        pdt_unit: "",
        pdt_tax_type_value: 0,
        pdt_incl_intra_price: "0.00",
        pdt_incl_inter_price: "0.00",
        pdt_pur_incl_intra_price: "0.00",
        pdt_pur_incl_inter_price: "0.00",
        pdt_tags: [],
        pdt_name: "",
        pdt_id: "",
        pdt_desc: "",
        pdt_tax_id: "",
        pdt_inter_tax_id: "",
        pdt_sales_account: "",
        pdt_sal_price: "",
        pdt_pur_price: "",
        pdt_hsn: "",
        pdt_sku: "",
        pdt_legacy_id: "",
        opening_stock: "",
        inventory_accounts: "",
        opening_stock_value: "",
        reorder_level: "",
        warehouse_id: "",
        tax_preference_value: "1",
        exempt_reason: "",
        pdt_upc: "",
        pdt_mpn: "",
        pdt_isbn: "",
        pdt_ean: "",
        pdt_length: "",
        pdt_width: "",
        pdt_height: "",
        pdt_wgt: "",
        purchase_desc: "",
        pdt_sale_price: "",
        pdt_purchase_account: "",
        is_selling_price:1,
        is_purchase_price:0,
        is_used:0,
        sales_desc: "",
      };
    },
    updateFields() {
      this.field = this.list.field; // assigning header value to the fiels datas
      // this.list.field.opening_stock = parseFloat(
      //   this.list.field.opening_stock
      // ).toFixed(2);
      // this.list.field.opening_stock_value = parseFloat(
      //   this.list.field.opening_stock_value
      // ).toFixed(2);
      this.field.pdt_sales_account = this.list.field.sales_account;
      this.old_goods_composite_itm_ids = this.list.old_goods_composite_itm_ids;
      this.old_service_composite_itm_ids = this.list.old_service_composite_itm_ids;
      if (
        this.list.field.exempt_reason == "" ||
        this.list.field.exempt_reason == null
      ) {
        this.field.exempt_reason = "";
      } else {
        this.field.exempt_reason = this.list.field.exempt_reason;
      }
      var i;
      for (i = 0; i < this.pdt_settings_details.custom_field.length; i++) {
        var val =
          this.$route.query.clone_id &&
          this.pdt_settings_details.custom_field[i].status == 0
            ? ""
            : this.list.field[
                this.pdt_settings_details.custom_field[i].field_name
              ];
        this.$set(
          this.field,
          this.pdt_settings_details.custom_field[i].field_name,
          val
        );
      }

      //update to fields for reporting tag field values
      for (var i = 0; i < this.reporting_tags.length; i++) {
        this.show_reporting_tag.push({
          used:
            this.list.field[this.reporting_tags[i].tag_column_name] != "" &&
            this.list.field[this.reporting_tags[i].tag_column_name] != null
              ? true
              : false,
          [this.reporting_tags[i].tag_column_name]: this.list.field[
            this.reporting_tags[i].tag_column_name
          ],
        });
        this.field[this.reporting_tags[i].tag_column_name] = this.list[
          this.reporting_tags[i].tag_column_name
        ]
          ? parseInt(this.list.field[this.reporting_tags[i].tag_column_name])
          : "";
      }
      // this.field.pdt_pur_price=parseFloat(this.list.field.pdt_pur_price).toFixed(2);
      var fields = this.field;
      var inter_Tax_id = this.list.field.pdt_inter_tax_id;
      var pdt_Tax_id = this.list.field.pdt_tax_id;
      $.each(this.igst_tax, (key, value) => {
        if (value["tax_id"] == inter_Tax_id) {
          this.inter_sales_tax_percent = value["sales_tax_percent"];
          fields.pdt_inter_tax_id = {
            label: value["tax_name"],
            value: value["tax_id"],
          };
        }
      });
      $.each(this.local_tax, (key, value) => {
        if (value["tax_id"] == pdt_Tax_id) {
          this.intra_sales_tax_percent = value["sales_tax_percent"];
          fields.pdt_tax_id = {
            label: value["tax_name"],
            value: value["tax_id"],
          };
        }
      });

      //  item details
      this.goods_items = this.list.goods_items;
      this.service_items = this.list.service_items;
      if (this.$route.query.clone_id) {
        this.field.pdt_id = "";
        this.field.pdt_sku = this.pdt_sku ? this.list.field.pdt_sku : "";
      }
    },
  },
  async created() {
    this.field.warehouse_id = this.primary_warehouse_details.warehouse_id;
    this.pdt_hsn = this.pdt_settings_details.pdt_hsn_sac;
    this.pdt_sku = this.pdt_settings_details.pdt_sku;
    this.allow_duplicate_pdt = this.pdt_settings_details.allow_duplicate_pdt;
    for (var i = 0; i < this.pdt_settings_details.custom_field.length; i++) {
      if (this.pdt_settings_details.custom_field[i].status == 1 && this.pdt_settings_details.custom_field[i].permissions == 'write') {
        this.$set(
          this.field,
          this.pdt_settings_details.custom_field[i].field_name,
          this.pdt_settings_details.custom_field[i].default_value
        );
      }
    }
    //set empty value for reporting tag fields
    for (var i = 0; i < this.reporting_tags.length; i++) {
      this.show_reporting_tag.push({
        used: "",
        [this.reporting_tags[i].tag_column_name]: "",
      });
      this.$set(this.field, this.reporting_tags[i].tag_column_name, "");
    }
    if (
      (this.$route.query.clone_id != "" &&
        typeof this.$route.query.clone_id != "undefined") ||
      this.$route.query.clone_id ||
      this.page == "update"
    ) {
      if (this.page == "update") {
        document.title = getPageTitle(
          this.list.field.pdt_name + " | " + this.$route.meta.title
        );
      }
      await this.updateFields();
    } else {
      this.update_price = true;
    }
    //  to watch any updates in field data
    await this.$watch(
      "field",
      function () {
        this.$emit("FormUpdate");
      },
      {
        deep: true,
      }
    );
    //  to watch any updates in item data
    await this.$watch(
      "goods_items",
      function () {
        this.$emit("FormUpdate");
      },
      {
        deep: true,
      }
    );
    await this.$watch(
      "service_items",
      function () {
        this.$emit("FormUpdate");
      },
      {
        deep: true,
      }
    );
  },
  updated: function () {
    this.$nextTick(function () {
      if (this.update_price == false) {
        //update prodcut price
        var i, j;
        for (i = 0; i < this.goods_items.length; i++) {
          var pdt_name = "pdt_name_typeahead_" + "goods_items" + i;
          this.$refs[pdt_name][0].inputValue = this.goods_items[i].products[
            i
          ].label;
          $("#vuebootsearcher" + "goods_items" + i + " input").addClass("mask");
          $("#vuebootsearcher" + "goods_items" + i + " .input-group").append(
            "<span class='la la-close p-2 remover cursor_pointer bg-white'></span>"
          );
        }
        for (i = 0; i < this.service_items.length; i++) {
          var pdt_name = "pdt_name_typeahead_" + "service_items" + i;
          this.$refs[pdt_name][0].inputValue = this.service_items[i].products[
            i
          ].label;
          $("#vuebootsearcher" + "service_items" + i + " input").addClass(
            "mask"
          );
          $("#vuebootsearcher" + "service_items" + i + " .input-group").append(
            "<span class='la la-close p-2 remover cursor_pointer bg-white'></span>"
          );
        }

        this.update_price = true;
      }
    });
  },
  //mapstate to fetch datas
  computed: {
    ...mapState({
      igst_tax: (state) => state.amcservice.igst_tax,
      local_tax: (state) => state.amcservice.local_tax,
      unit_list: (state) => state.amcservice.unit_list,
      sales_account: (state) => state.amcservice.sales_account,
      producttaglist: (state) => state.amcservice.producttaglist,
      product_filter_list: (state) => state.general.product_filter_list,
      list: (state) => state.amcservice.list,
      inventory_accounts: (state) => state.amcservice.inventory_accounts,
      acc_types: (state) => state.products.acc_types,
      exempt_reason_list: (state) => state.amcservice.exempt_reason_list,
      updatedtag_id: (state) => state.products.updatedtag_id,
      purchase_account: (state) => state.amcservice.purchase_account,
      message: (state) => state.amcservice.message,
    }),
    ...mapGetters([
      "org_details",
      "orgCurrency",
      "orgCurrencySymbol",
      "primary_warehouse_details",
      "reporting_tags",
      "pdt_settings_details",
    ]),
  },
};
</script>
<!--script for product create pages -->
<!--style for product create pages -->
<style lang="scss" scoped>
.type {
  max-width: 90% !important;
}
.table.total-table tbody + tbody {
  border: 0 !important;
}
</style>